import React, { useState, useEffect } from "react";
import { useProfile } from "../../../contexts/ProfileContext";
import { postApi } from "../../AppApis";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import SettingHeader from "../../../components/SettingPageHeader/SettingHeader";
import { FaRegEdit, FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { showErrorToast, showSuccessToast } from "../../utils";
import { CircularProgress } from "@mui/material";
export default function ChangePassword() {
    const navigate = useNavigate(); // Initialize the navigate function

    const { profileData } = useProfile();
    const [isLoading, setIsLoading] = useState(false);
    const [payload, setPayload] = useState({
        email: profileData?.email,
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
    });
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const passwordRegx = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$/;

    // Clear form on component mount to prevent password persistence
    useEffect(() => {
        setPayload({
            email: profileData?.email,
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
        });
    }, [profileData?.email]);
    const handleButtonClick = async () => {
        try {
            if (!payload.oldPassword || !payload.newPassword || !payload.confirmPassword) {
                toast.error("Please fill all fields", { toastId: "errorToast" });
                return;
            } else if (payload.newPassword !== payload.confirmPassword) {
                toast.error("New Password and Confirm Password should be same", { toastId: "errorToast" });
                return;
            } else if (payload.oldPassword === payload.newPassword) {
                return toast.error("New Password and Old Password should be different", { toastId: "errorToast" });
            } else if (!passwordRegx.test(payload.newPassword)) {
                return toast.error("Password must be at least 8 characters long and contain at least one letter and one number.", {
                    toastId: "errorToast",
                });
            }
            setIsLoading(true);
            const updatedPayload = {
                email: payload.email,
                new_password: payload.newPassword,
                current_password: payload.oldPassword,
            };
            const response = await postApi("/user/change-password", updatedPayload);
            if (response?.error?.detail) {
                showErrorToast(response?.error?.detail, {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
            } else {
                showSuccessToast("Password updated successfully", {
                    autoClose: 3000,
                    pauseOnHover: false,
                    toastId: "successToast",
                });
                setPayload({
                    email: profileData?.email,
                    oldPassword: "",
                    newPassword: "",
                    confirmPassword: "",
                });
                navigate("/sign-in-security");
            }
        } catch (error) {
            console.log("Error:", error);
            showErrorToast("An error occurred. Please try again.", {
                autoClose: 3000,
                pauseOnHover: false,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Header title="Change Password" />
            <div className="tw-p-[20px]">
                <SettingHeader title="Change Password" />
                <div className="tw-p-[20px] tw-text-black tw-w-full tw-items-center tw-flex tw-flex-col ">
                    <div className="tw-flex tw-flex-col tw-bg-white tw-rounded-xl tw-p-[20px] tw-gap-4 tw-mt-10 tw-w-full lg:tw-w-[70%]">
                        <div>
                            <p className="tw-text-sm tw-font-medium tw-mb-1">Email</p>
                            <div className="tw-relative  tw-rounded-md">
                                <input
                                    value={payload.email}
                                    disabled
                                    type="text"
                                    placeholder="example@gmail.com"
                                    className="tw-w-full tw-text-[14px] tw-bg-white tw-border tw-border-gray-300 tw-mt-2 tw-px-4 tw-py-2 tw-rounded-md tw-pr-10"
                                />

                                <FaRegEdit
                                    onClick={() => navigate("/change-email")}
                                    className="tw-absolute tw-top-6 tw-right-3  tw-text-[20px] -tw-translate-y-1/2 tw-text-gray-400"
                                />
                            </div>
                        </div>
                        <div className="tw-relative">
                            <p>Old Password</p>
                            <input
                                value={payload.oldPassword}
                                onChange={(e) => setPayload({ ...payload, oldPassword: e.target.value })}
                                type={showOldPassword ? "text" : "password"}
                                placeholder="Enter your old password"
                                autoComplete="off"
                                className="tw-w-full tw-bg-white tw-text-[12px] tw-border tw-border-background_secondary_color tw-mt-2 tw-px-4 tw-py-2 tw-rounded-md"
                            />
                            <button
                                type="button"
                                onClick={() => setShowOldPassword((prev) => !prev)}
                                className="tw-absolute tw-right-3 tw-top-11 max-sm:tw-top-3"
                            >
                                {showOldPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                            </button>
                        </div>
                        <div className="tw-relative">
                            <p>New Password</p>
                            <input
                                value={payload.newPassword}
                                onChange={(e) => setPayload({ ...payload, newPassword: e.target.value })}
                                type={showNewPassword ? "text" : "password"}
                                placeholder="Enter your new password"
                                autoComplete="new-password"
                                className="tw-w-full tw-bg-white tw-text-[12px] tw-border tw-border-background_secondary_color tw-mt-2 tw-px-4 tw-py-2 tw-rounded-md"
                            />
                            <button
                                type="button"
                                onClick={() => setShowNewPassword((prev) => !prev)}
                                className="tw-absolute tw-right-3 tw-top-11 max-sm:tw-top-3"
                            >
                                {showNewPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                            </button>
                        </div>
                        <div className="tw-relative">
                            <p>Confirm Password</p>
                            <input
                                value={payload.confirmPassword}
                                onChange={(e) => setPayload({ ...payload, confirmPassword: e.target.value })}
                                type={showNewPassword ? "text" : "password"}
                                placeholder="Enter your confirm password"
                                autoComplete="new-password"
                                className="tw-w-full tw-bg-white tw-text-[12px] tw-border tw-border-background_secondary_color tw-mt-2 tw-px-4 tw-py-2 tw-rounded-md"
                            />
                        </div>
                        <div className="tw-w-full tw-flex tw-justify-center">
                            <button
                                onClick={handleButtonClick}
                                disabled={isLoading}
                                className="tw-bg-primary hover:tw-bg-primary_hover tw-font-Space_Grotesk tw-w-fit tw-p-1 tw-px-4 2xl:tw-text-[22px] between:tw-text-[18px] tw-rounded-md tw-text-white tw-flex tw-items-center tw-gap-1 tw-justify-center tw-mb-2 tw-mt-1 2xl:tw-mt-4 2xl:tw-mb-6 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                            >
                                {isLoading ? (
                                    <>
                                        <CircularProgress size={16} color="inherit" />
                                        Updating...
                                    </>
                                ) : (
                                    "Update"
                                )}
                            </button>
                        </div>
                    </div>{" "}
                </div>
            </div>
        </>
    );
}
